import styled from "styled-components";

const UserNickName = styled.span`
  padding: 0;
  margin: 0;
  opacity: 0.4;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #141f2d;
  font-family: "Kumbh Sans";
`;

export default UserNickName;
